import { MAP_TOOL, PANEL } from '../constants.js';
export const deriveUIManagerStateFromConfig = () => {
    return {
        visiblePanel: PANEL.NONE,
        activeMapTool: MAP_TOOL.NONE,
        defaultMapTool: MAP_TOOL.INFOEDIT,
    };
};
//# sourceMappingURL=deriveUIManagerStateFromConfig.js.map